const SET_NOTIFICATIONS = (state, payload) => {
  state.list = payload
}

const REMOVE_NOTIFICATION = (state, payload) => {
  state.list = state.list.filter((notification) => {
    return notification.id !== payload.id
  })
}

export default {
  SET_NOTIFICATIONS,
  REMOVE_NOTIFICATION
}



// WEBPACK FOOTER //
// ./src/features/notifications/store/mutations.js